// Org chart (NEXUS-740): wire types and the small pure helpers the Happening-now Org view uses.

export type AgentStatus = 'idle' | 'working' | 'waiting' | 'blocked' | 'off';
export interface OrgLink { kind: 'issue' | 'project' | 'initiative' | 'approval'; ref: string; instance?: string }
export interface OrgAgent {
  id: string; key: string; name: string; title?: string | null; kind: 'head' | 'lead' | 'task' | 'sub'; lane?: string | null;
  memoryScope?: string | null; charter?: string | null; status: AgentStatus; currentTask?: string | null; runRef?: string | null;
  links: OrgLink[]; openLinks: number; children: OrgAgent[];
}
export interface OrgDepartment { id: string; key: string; name: string; agentCount: number; activeCount: number; agents: OrgAgent[] }
export interface OrgSummary { agents: number; working: number; waiting: number; blocked: number; off: number }
export interface OrgChart { departments: OrgDepartment[]; summary: OrgSummary }

export const STATUS_TONE: Record<AgentStatus, 'green' | 'orange' | 'red' | 'neutral'> = {
  working: 'green', waiting: 'orange', blocked: 'red', idle: 'neutral', off: 'neutral',
};

/** Where a link chip goes in the console: issues open the Issues tab searched by key, projects their page. */
export function linkHref(l: OrgLink): string {
  switch (l.kind) {
    case 'issue': return `/issues?q=${encodeURIComponent(l.ref)}`;
    case 'project': return `/projects/${encodeURIComponent(l.ref)}`;
    default: return '/waiting';
  }
}

/** Every agent in a department tree, parents before children. */
export function flatten(agents: OrgAgent[]): OrgAgent[] {
  return agents.flatMap((a) => [a, ...flatten(a.children)]);
}
